/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2021 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import { API } from "../api/api";
import logger from "../helpers/logger";
import { setApiError } from "../slices/errorHandlingSlice";
import { endSession } from "../slices/goTrackUserSlice";
import * as authUtils from "./auth/authUtils";
import { v4 as uuidv4 } from "uuid";
import { clearUserContext } from "../telemetryService";

const setupApiInterceptors = (dispatch) => {
  API.interceptors.request.use(
    async (config) => {
      const correlationId = uuidv4();
      window.loadingApiKey = true;
      let apiAccessToken;

      try {
        apiAccessToken = await authUtils.getApiToken();
      } catch (error) {
        clearUserContext();
        dispatch(endSession());
        throw new API.Cancel();
      }

      window.loadingApiKey = undefined;

      if (!config) {
        config = {};
      }

      if (apiAccessToken) {
        config.headers = {
          Authorization: "Bearer " + apiAccessToken,
          "x-correlation-id": correlationId,
        };
      } else {
        dispatch(endSession());
        throw new API.Cancel();
      }

      return config;
    },
    (error) => {
      const { method, url, baseURL, params, data } = error.config;
      logger.error(error, { method, url, baseURL, params, data });
    }
  );

  API.interceptors.response.use(
    (res) => res,
    (error) => {
      const { method, url, baseURL, params, data } = error.config;
      logger.error(error, { method, url, baseURL, params, data });
      const { request, response } = error;
      if (request.status === 401) {
        // force user to log in again if unauthorized
        clearUserContext();
        dispatch(endSession());
        return;
      } else if (!response || response.status >= 500) {
        // display error modal for network and server errors
        dispatch(setApiError());
        return;
      }
      throw error;
    }
  );
};

export default setupApiInterceptors;
